import React, { useState } from 'react';
import {
  Box,
  Typography,
  Stack,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Button,
  IconButton,
  Checkbox,
  FormControlLabel,
  CircularProgress,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import config from '../../Config';

const exampleGroups = ['Main Entrance', 'Floor 1', 'Floor 2', 'VIP Area'];

export default function AddTTLockForm({ onCancel, onSuccess }) {
  const [lockName, setLockName] = useState('');
  const [lockAlias, setLockAlias] = useState('');
  const [groupName, setGroupName] = useState('');
  const [hasGateway, setHasGateway] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${config.apiBaseUrl}/ttlock/add`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ lockName, lockAlias, groupName, hasGateway }),
      });
      const data = await res.json();

      if (res.ok) {
        onSuccess();
      } else {
        alert(data.message || 'Failed to add lock');
      }
    } catch (err) {
      alert('Error adding lock');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        maxWidth: 700,
        mx: 'auto',
        mt: 5,
        p: 4,
        boxShadow: 6,
        borderRadius: 3,
        bgcolor: 'background.paper',
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1} mb={3}>
        <IconButton
          onClick={onCancel}
          size="medium"
          aria-label="Back to list"
          sx={{
            bgcolor: 'grey.100',
            '&:hover': {
              bgcolor: 'grey.200',
            },
            boxShadow: 1,
          }}
        >
          <ArrowBackIcon fontSize="medium" />
        </IconButton>
        <Typography variant="h5" fontWeight={600} ml={1} color="primary.dark">
          Add New TT Lock
        </Typography>
      </Stack>

      <Stack spacing={3}>
        <TextField
          label="Lock Name"
          value={lockName}
          onChange={(e) => setLockName(e.target.value)}
          required
          fullWidth
          size="medium"
          placeholder="Enter lock name"
        />

        <TextField
          label="Lock Alias"
          value={lockAlias}
          onChange={(e) => setLockAlias(e.target.value)}
          fullWidth
          size="medium"
          placeholder="Optional friendly name"
        />

        <FormControl fullWidth required size="medium" variant="outlined">
          <InputLabel id="group-label">Group Name</InputLabel>
          <Select
            labelId="group-label"
            value={groupName}
            label="Group Name"
            onChange={(e) => setGroupName(e.target.value)}
          >
            {exampleGroups.map((group) => (
              <MenuItem key={group} value={group}>
                {group}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControlLabel
          control={
            <Checkbox
              checked={hasGateway}
              onChange={(e) => setHasGateway(e.target.checked)}
              color="primary"
              size="medium"
            />
          }
          label="Has Gateway"
        />
      </Stack>

      <Stack direction="row" spacing={2} justifyContent="flex-end" pt={4}>
        <Button variant="outlined" onClick={onCancel} disabled={loading}>
          Cancel
        </Button>
        <Button type="submit" variant="contained" disabled={loading}>
          {loading ? <CircularProgress size={24} color="inherit" /> : 'Add Lock'}
        </Button>
      </Stack>
    </Box>
  );
}
